import { ObjectTools } from '../../tools/object-tools';
import { SolViewId } from '../core/sol-view-id';

export class SolTableColumnDef<V, O> {
  private constructor(
    public readonly id: string,
    public readonly dataPath: string,
    public readonly name: string,
    public readonly viewId?: SolViewId<O>,
    public readonly nameTranslatable: boolean = true,
    public readonly viewOptions: Partial<O> = {},
    public readonly sortable: boolean = false,
    public readonly hideable: boolean = true,
    public readonly visible: boolean = true,
    public readonly layout?: string, // grid-template-columns entry (e.g. '1fr', 'auto', '30px', 'min-content')
  ) {}

  /**
   * Creates a table column definition builder.
   */
  public static of<V, O>(dataPath: string, name: string, viewId?: SolViewId<O>): SolTableColumnDef<V, O> {
    return new SolTableColumnDef<V, O>(dataPath, dataPath, name, viewId);
  }

  public withId(id: string): SolTableColumnDef<V, O> {
    return this.copy({ id });
  }

  public withViewOptions(viewOptions: Partial<O>): SolTableColumnDef<V, O> {
    return this.copy({ viewOptions });
  }

  public withNameTranslatable(nameTranslatable: boolean): SolTableColumnDef<V, O> {
    return this.copy({ nameTranslatable });
  }

  public withSortable(sortable: boolean): SolTableColumnDef<V, O> {
    return this.copy({ sortable });
  }

  public withHideable(hideable: boolean): SolTableColumnDef<V, O> {
    return this.copy({ hideable });
  }

  public withVisible(visible: boolean): SolTableColumnDef<V, O> {
    return this.copy({ visible });
  }

  public withLayout(layout?: string): SolTableColumnDef<V, O> {
    return this.copy({ layout });
  }

  private copy(props: Partial<SolTableColumnDef<V, O>>): SolTableColumnDef<V, O> {
    return ObjectTools.copy<SolTableColumnDef<V, O>>(this, props);
  }
}
